(() => {
  const label = document.currentScript?.dataset.loyaltyLabel;
  if (!label) return;
  const update = () => {
    document.querySelectorAll('.BLOY-widget__title').forEach((element) => {
      if (element.textContent.trim() === 'Lojalitets Program') element.textContent = label;
    });
  };
  update();
  new MutationObserver((records) => {
    if (records.some((record) => record.addedNodes.length)) update();
  }).observe(document.body, {childList:true,subtree:true});
})();
